module.exports = __webpack_public_path__ + "static/media/9DESA11.4cd741e1.jpg";